<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'Namirembe Diocese Young Sacco',

  data() {
    return {

    };
  },

  mounted() { },

  methods: {},
};
</script>

<style lang="scss" scoped></style>